import { FormattedNumber } from 'react-intl';
import { PureComponent } from 'react';

import * as distanceUtils from '../../utils/distanceUtils';
import { IWithContextProps, withContext } from '@tock/coretypes';

interface Props {
  meters: number;
  locale?: string;
}

/**
 * Displays a distance in the current locale.
 */
/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
class DisplayDistance extends PureComponent<Props & IWithContextProps> {
  render() {
    const {
      meters,
      context: { locale: localeFromContext },
      locale: localeFromProps,
    } = this.props;

    const locale = localeFromProps || localeFromContext;
    const unit = distanceUtils.unitsForLocale(locale);
    const adjustedValue =
      unit === 'miles'
        ? distanceUtils.metersToMiles(meters)
        : distanceUtils.metersToKilometers(meters);

    return (
      <span>
        {/* React intl blows up in Safari when trying to use style='unit' */}
        <FormattedNumber maximumFractionDigits={1} locales={[locale]} value={adjustedValue} />{' '}
        {unit}
      </span>
    );
  }
}

export default withContext(DisplayDistance);
